const DuplicatePropertiesCard = ({ groups, errorMessage }) => {
  return (
    <section className="panel-card admin-re-quality-card">
      <p className="eyebrow">Dedup review</p>
      <h3>Possible duplicates</h3>
      <p className="muted admin-re-quality-note">
        Duplicates are heuristic and should be reviewed before merging.
      </p>

      {errorMessage ? <p className="admin-data-health-error">{errorMessage}</p> : null}

      {!errorMessage && !groups?.length ? (
        <p className="muted">No duplicate groups in this sample.</p>
      ) : null}

      {!errorMessage && groups?.length ? (
        <div className="admin-re-duplicate-groups">
          {groups.map((group) => (
            <article key={group.duplicateKey} className="admin-re-duplicate-group">
              <header>
                <strong>{group.count} listings</strong>
                <span className="muted">key {group.duplicateKey.slice(0, 8)}…</span>
              </header>
              <ul className="admin-re-quality-list">
                {group.properties.map((property) => (
                  <li key={property.id}>
                    <strong>{property.title}</strong>
                    <span>
                      {property.displaySource || property.sourceCode}
                      {property.price !== null
                        ? ` · ${property.currencyCode} ${property.price}`
                        : ""}
                      {property.bedrooms !== null ? ` · ${property.bedrooms} bed` : ""}
                      {property.bathrooms !== null ? ` · ${property.bathrooms} bath` : ""}
                    </span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      ) : null}
    </section>
  );
};

export default DuplicatePropertiesCard;
